export default __webpack_public_path__ + "static/media/wechat.ccd82048.svg";